<div class="flex h-screen bg-base-200 overflow-hidden">

  <!-- Fondo oscurecido del cajón (sólo móvil): tocar fuera cierra el menú -->
  @if (esMovil() && sidebarOpen()) {
    <div class="fixed inset-0 bg-black/50 z-40 lg:hidden" (click)="toggleSidebar()" aria-hidden="true"></div>
  }

  <!-- Sidebar · cajón deslizante en móvil, barra fija (ancha o angosta) en escritorio -->
  <aside class="flex flex-col bg-neutral text-neutral-content shrink-0 w-64 transition-all duration-300
                fixed inset-y-0 left-0 z-50 lg:static lg:z-40"
    [class]="sidebarOpen() ? 'translate-x-0 lg:w-64' : '-translate-x-full lg:translate-x-0 lg:w-16'">

    <!-- Logo -->
    <div class="flex items-center h-16 px-4 border-b border-neutral-content/10 shrink-0">
      @if (sidebarOpen()) {
      <div class="flex items-center gap-2 flex-1 min-w-0">
        <div class="w-8 h-8 rounded-lg bg-secondary/15 flex items-center justify-center overflow-hidden shrink-0">
          @if (currentUser()?.logoUrl) {
            <img [src]="currentUser()?.logoUrl" alt="Logo del taller" class="w-full h-full object-contain" />
          } @else {
            <mk-logo variant="isotipo" [size]="20" class="text-neutral-content" />
          }
        </div>
        <div class="flex flex-col flex-1 min-w-0">
          <span class="font-bold text-[11px] leading-tight whitespace-normal break-words py-1">
            {{ currentUser()?.user?.grupo === 'SUPER_ADMIN' ? 'Panel Master' : (currentUser()?.nombreTaller || 'SIGA') }}
          </span>
          
          <!-- Selector de Sucursal -->
          @if ((currentUser()?.user?.sucursales?.length || 0) > 0) {
            <div class="dropdown dropdown-bottom w-full">
              <!-- Los `!` son a propósito: el SDK de Clip inyecta un reset sin @layer
                   (button { padding:0; border:0; font:inherit; background:none }) que le
                   gana a las utilidades de Tailwind en cualquier <button> que no sea .btn. -->
              <button type="button" tabindex="0" class="flex items-center gap-1 text-[9px]! font-black! uppercase opacity-50 hover:opacity-100 transition-opacity">
                <i class="ri-map-pin-2-fill text-secondary"></i>
                <span class="truncate max-w-[120px]">{{ currentUser()?.user?.sucursalActiva?.nombre || 'Sin Sede' }}</span>
                @if ((currentUser()?.user?.sucursales?.length || 0) > 1) {
                  <i class="ri-arrow-down-s-line"></i>
                }
              </button>
              @if ((currentUser()?.user?.sucursales?.length || 0) > 1) {
                <!-- Cada sede es una opción tipo radio: viñeta vacía/llena + separador,
                     así los nombres largos no se funden en un solo bloque de texto. -->
                <ul tabindex="0" role="menu" aria-label="Seleccionar sucursal"
                  class="dropdown-content z-[50] p-2 shadow-2xl bg-neutral border border-white/10 rounded-2xl w-64 max-w-[calc(100vw-2rem)] mt-2 space-y-1"
                  [class.hidden]="switchingBranch()">
                  <li class="text-[9px] font-black uppercase tracking-widest text-neutral-content/40 px-3 pt-1 pb-2">Seleccionar sucursal</li>
                  @for (s of (currentUser()?.user?.sucursales || []); track s.id) {
                    @let activa = s.id === currentUser()?.user?.sucursalActiva?.id;
                    <li>
                      <button type="button" role="menuitemradio" [attr.aria-checked]="activa" (click)="setSucursal(s)"
                        class="w-full flex items-center gap-3 text-left px-3! py-2.5! rounded-xl border! border-solid! transition-colors"
                        [class]="activa
                          ? 'bg-secondary/20! border-secondary/60! text-white'
                          : 'border-transparent! text-neutral-content/70 hover:bg-white/5! hover:text-neutral-content'">
                        <!-- Viñeta tipo radio -->
                        <span class="shrink-0 w-4 h-4 rounded-full border-2 flex items-center justify-center"
                          [class]="activa ? 'border-secondary' : 'border-neutral-content/40'" aria-hidden="true">
                          @if (activa) {
                            <span class="w-2 h-2 rounded-full bg-secondary"></span>
                          }
                        </span>
                        <span class="flex-1 min-w-0 text-[11px] font-bold uppercase leading-snug break-words">{{ s.nombre }}</span>
                        @if (activa) {
                          <span class="shrink-0 text-[8px] font-black uppercase tracking-widest text-secondary">Actual</span>
                        }
                      </button>
                    </li>
                  }
                </ul>
              }
            </div>
          }
        </div>
      </div>
      } @else {
      <div class="w-8 h-8 rounded-lg bg-secondary/15 flex items-center justify-center mx-auto overflow-hidden">
        @if (currentUser()?.logoUrl) {
          <img [src]="currentUser()?.logoUrl" alt="Logo del taller" class="w-full h-full object-contain" />
        } @else {
          <mk-logo variant="isotipo" [size]="20" class="text-neutral-content" />
        }
      </div>
      }
      <!-- Toggle del menú · swap-rotate (menú ↔ flecha) -->
      <label class="swap swap-rotate btn btn-ghost btn-sm btn-square ml-auto text-neutral-content/60 hover:text-neutral-content"
        title="Contraer o expandir el menú">
        <input type="checkbox" [checked]="sidebarOpen()" (change)="toggleSidebar()" aria-hidden="true" />
        <i class="swap-on ri-arrow-left-s-line text-xl" aria-hidden="true"></i>
        <i class="swap-off ri-menu-line text-lg" aria-hidden="true"></i>
      </label>
    </div>

    <!-- Navigation -->
    <ng-template #navLink let-item>
      <a [routerLink]="item.route" (click)="onNavClick()"
        class="relative flex items-center gap-3 px-3 py-2.5 rounded-lg mb-0.5 transition-colors cursor-pointer" [class]="isActive(item.route)
            ? 'bg-secondary text-white font-semibold shadow-md shadow-secondary/30 before:absolute before:left-0 before:top-1.5 before:bottom-1.5 before:w-1 before:rounded-full before:bg-white'
            : 'text-neutral-content/60 hover:bg-neutral-content/10 hover:text-neutral-content'">
        <i [class]="iconFor(item) + ' text-lg shrink-0'"></i>
        @if (sidebarOpen()) {
        <span class="text-sm font-medium truncate">{{ item.label }}</span>
        }
      </a>
    </ng-template>

    <nav class="flex-1 overflow-y-auto py-3 px-2">
      <!-- Operación diaria: lo que se usa en piso, también desde el celular -->
      @for (item of menuPrincipal(); track item.route) {
        <ng-container *ngTemplateOutlet="navLink; context: { $implicit: item }"></ng-container>
      }

      @if (menuEscritorio().length) {
        <!-- Escritorio: los módulos administrativos van seguidos, sin fricción -->
        <div class="hidden lg:block">
          @for (item of menuEscritorio(); track item.route) {
            <ng-container *ngTemplateOutlet="navLink; context: { $implicit: item }"></ng-container>
          }
        </div>

        <!-- Móvil/tablet: replegados. Se pueden abrir para consultar, pero no
             compiten con las tareas de campo ni invitan a capturar en pantalla chica. -->
        <div class="lg:hidden mt-2 pt-2 border-t border-neutral-content/10">
          <button type="button" (click)="mostrarEscritorio.set(!mostrarEscritorio())"
            class="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-neutral-content/50 hover:bg-neutral-content/10 hover:text-neutral-content transition-colors">
            <i class="ri-briefcase-4-line text-lg shrink-0"></i>
            <span class="text-[11px] font-black uppercase tracking-widest flex-1 text-left">Administración</span>
            <i class="text-lg" [class]="mostrarEscritorio() ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'"></i>
          </button>
          @if (mostrarEscritorio()) {
            <p class="px-3 pb-2 text-[10px] leading-tight text-neutral-content/40">
              Estos módulos están pensados para escritorio; en el celular úsalos sólo para consultar.
            </p>
            @for (item of menuEscritorio(); track item.route) {
              <ng-container *ngTemplateOutlet="navLink; context: { $implicit: item }"></ng-container>
            }
          }
        </div>
      }
    </nav>

    <!-- Notificaciones · antes flotaban sobre el contenido; ahora viven en el menú -->
    <div class="px-2 pt-2 border-t border-neutral-content/10 shrink-0">
      <div class="dropdown dropdown-top w-full">
        <button type="button" tabindex="0" (focus)="refreshNotificaciones()" (mouseenter)="refreshNotificaciones()"
          [title]="sidebarOpen() ? '' : 'Notificaciones'"
          class="relative w-full flex items-center gap-3 px-3! py-2.5! rounded-lg transition-colors hover:bg-neutral-content/10!"
          [class]="totalNotificaciones() > 0 ? 'text-neutral-content' : 'text-neutral-content/60 hover:text-neutral-content'">
          <!-- Con pendientes la campana se mueve (ver .campana-alerta en styles.css) -->
          <i class="text-lg shrink-0" aria-hidden="true"
            [class]="totalNotificaciones() > 0 ? 'ri-notification-3-fill text-secondary campana-alerta' : 'ri-notification-3-line'"></i>
          @if (sidebarOpen()) {
            <span class="text-sm font-medium truncate flex-1 text-left">Notificaciones</span>
            @if (totalNotificaciones() > 0) {
              <span class="badge badge-error badge-sm font-bold">{{ totalNotificaciones() }}</span>
            }
          } @else if (totalNotificaciones() > 0) {
            <span class="absolute top-1.5 right-2 w-2.5 h-2.5 rounded-full bg-error animate-ping opacity-75"></span>
            <span class="absolute top-1.5 right-2 w-2.5 h-2.5 rounded-full bg-error"></span>
          }
        </button>
        <div tabindex="0" class="dropdown-content z-[100] shadow-2xl bg-base-100 text-base-content rounded-2xl w-80 max-w-[calc(100vw-2rem)] mb-2 border border-base-200 p-0 overflow-hidden">
          <div class="bg-primary/5 p-4 border-b border-base-200 flex justify-between items-center">
            <span class="font-black text-[10px] uppercase tracking-widest text-primary">Notificaciones</span>
            @if (totalNotificaciones() > 0) {
              <span class="badge badge-error badge-sm font-bold shadow-sm">{{ totalNotificaciones() }} Pendientes</span>
            } @else {
              <span class="badge badge-ghost badge-sm font-bold">0 Pendientes</span>
            }
          </div>
          <div class="max-h-[60vh] overflow-y-auto p-2 space-y-1">

            @if (totalNotificaciones() === 0 && !alertas.resumen()?.cobranza?.saldo_total) {
              <div class="p-4 text-center opacity-50">
                <i class="ri-check-double-line text-3xl mb-2 block"></i>
                <p class="text-xs font-bold">Todo al día</p>
              </div>
            }

            <!-- Pendientes del taller: un renglón por tema, con liga a donde se resuelve -->
            @if (alertas.resumen(); as a) {
              @if (a.cobranza.saldo_total > 0) {
                <a routerLink="/contabilidad/cobranza" (click)="onNavClick()"
                   class="block p-3 rounded-xl border hover:brightness-95"
                   [class]="a.cobranza.vencido.saldo > 0 ? 'bg-error/5 border-error/30' : 'bg-base-200/50 border-base-300'">
                  <span class="font-bold text-xs flex items-center gap-1.5" [class]="a.cobranza.vencido.saldo > 0 ? 'text-error' : 'text-base-content/70'">
                    <i class="ri-hand-coin-line"></i> Cobranza
                  </span>
                  <p class="text-[11px] leading-tight mt-0.5">
                    <strong>{{ a.cobranza.saldo_total | currency }}</strong> por cobrar en {{ a.cobranza.documentos }} {{ a.cobranza.documentos === 1 ? 'venta' : 'ventas' }}.
                    @if (a.cobranza.vencido.saldo > 0) {
                      <span class="text-error font-bold">{{ a.cobranza.vencido.saldo | currency }} con más de {{ a.cobranza.vencido.dias }} días.</span>
                    }
                  </p>
                  <ul class="mt-1 space-y-0.5">
                    @for (c of a.cobranza.clientes.slice(0, 3); track c.cliente_id) {
                      <li class="flex justify-between gap-2 text-[10px] opacity-80">
                        <span class="truncate">{{ c.cliente_nombre }}</span>
                        <span class="shrink-0 font-mono">{{ c.saldo | currency:'MXN':'symbol-narrow':'1.0-0' }} · {{ c.dias_max }} d</span>
                      </li>
                    }
                  </ul>
                </a>
              }
              @if (a.ordenes_por_cerrar.total > 0) {
                <a routerLink="/ordenes-por-cerrar" (click)="onNavClick()" class="block p-3 bg-warning/5 rounded-xl border border-warning/30 hover:bg-warning/10">
                  <span class="font-bold text-xs flex items-center gap-1.5 text-warning"><i class="ri-checkbox-multiple-line"></i> Órdenes por cerrar</span>
                  <p class="text-[11px] opacity-80 leading-tight mt-0.5">
                    {{ a.ordenes_por_cerrar.total }} {{ a.ordenes_por_cerrar.total === 1 ? 'orden terminada sigue abierta' : 'órdenes terminadas siguen abiertas' }}
                    @if (a.ordenes_por_cerrar.sin_venta.count) { · {{ a.ordenes_por_cerrar.sin_venta.count }} sin cobrar ({{ a.ordenes_por_cerrar.sin_venta.total | currency:'MXN':'symbol-narrow':'1.0-0' }}) }
                    @if (a.ordenes_por_cerrar.a_credito.count) { · {{ a.ordenes_por_cerrar.a_credito.count }} a crédito }.
                    Si ya te pagaron, ciérralas en bloque.
                  </p>
                </a>
              }
              @if (a.costos_pendientes.lineas > 0) {
                <a routerLink="/contabilidad/por-costear" (click)="onNavClick()" class="block p-3 bg-info/5 rounded-xl border border-info/30 hover:bg-info/10">
                  <span class="font-bold text-xs flex items-center gap-1.5 text-info"><i class="ri-price-tag-3-line"></i> Piezas sin costo</span>
                  <p class="text-[11px] opacity-80 leading-tight mt-0.5">
                    {{ a.costos_pendientes.lineas }} {{ a.costos_pendientes.lineas === 1 ? 'pieza vendida' : 'piezas vendidas' }} sin precio de compra
                    ({{ a.costos_pendientes.importe_venta | currency:'MXN':'symbol-narrow':'1.0-0' }} de venta). Mientras no las costees, tu utilidad sale inflada.
                  </p>
                </a>
              }
              @if (veRecordatorios() && a.recordatorios.total > 0) {
                <a routerLink="/recordatorios" (click)="onNavClick()" class="block p-3 bg-success/5 rounded-xl border border-success/30 hover:bg-success/10">
                  <span class="font-bold text-xs flex items-center gap-1.5 text-success"><i class="ri-alarm-line"></i> Clientes por contactar</span>
                  <p class="text-[11px] opacity-80 leading-tight mt-0.5">
                    A {{ a.recordatorios.total }} {{ a.recordatorios.total === 1 ? 'vehículo le toca' : 'vehículos les toca' }} servicio
                    @if (a.recordatorios.vencidos) { ({{ a.recordatorios.vencidos }} ya vencidos) }. Mándales un WhatsApp.
                  </p>
                </a>
              }
            }

            @for (t of traspasosPendientes(); track t.id) {
              <div class="p-3 bg-base-100 rounded-xl border border-base-300 hover:bg-base-200/50 transition-colors cursor-pointer">
                <div class="flex items-center justify-between w-full mb-1">
                  <span class="font-bold text-xs flex items-center gap-1.5 text-info"><i class="ri-truck-line"></i> Traspaso en Camino</span>
                  <span class="text-[9px] font-bold opacity-40 uppercase">{{ t.createdAt | date:'shortTime' }}</span>
                </div>
                <p class="text-[11px] opacity-70 leading-tight">
                  Envío de <strong>{{ t.items.length }}</strong> {{ t.items.length === 1 ? 'producto' : 'tipos de productos' }} en camino hacia tu sucursal:
                </p>
                @if (t.creado_por?.nombre) {
                  <p class="text-[10px] opacity-60 mt-0.5 flex items-center gap-1"><i class="ri-user-line"></i> Enviado por <strong>{{ t.creado_por?.nombre }}</strong></p>
                }
                <ul class="mt-1.5 space-y-1">
                  @for (it of t.items; track it.item_id) {
                    <li class="flex items-center justify-between gap-2 text-[10px] bg-base-200/60 rounded-lg px-2 py-1">
                      <span class="truncate font-semibold">{{ it.nombre || 'Producto' }}@if (it.no_parte) {<span class="opacity-50 font-normal"> · {{ it.no_parte }}</span>}</span>
                      <span class="badge badge-info badge-xs font-bold shrink-0">x{{ it.cantidad }}</span>
                    </li>
                  }
                </ul>
                <button (click)="confirmarTraspaso(t)" class="btn btn-xs btn-ghost w-full mt-2 text-info text-[10px] font-bold bg-info/10">Confirmar Recepción</button>
              </div>
            }

            @for (n of comunicacion.novedadesSinLeer(); track n.id) {
              <div class="p-3 bg-success/5 rounded-xl border border-success/30">
                <div class="flex items-center justify-between w-full mb-1">
                  <span class="font-bold text-xs flex items-center gap-1.5 text-success">
                    <i [class]="n.tipo === 'FIX' ? 'ri-tools-line' : n.tipo === 'AVISO' ? 'ri-megaphone-line' : 'ri-sparkling-2-line'"></i>
                    {{ n.tipo === 'FIX' ? 'Corrección' : n.tipo === 'AVISO' ? 'Aviso' : 'Nueva función' }}
                    @if (n.version) { <span class="opacity-60 font-mono">v{{ n.version }}</span> }
                  </span>
                  <span class="text-[9px] font-bold opacity-40 uppercase">{{ n.createdAt | date:'dd/MM' }}</span>
                </div>
                <p class="text-[11px] font-bold leading-tight">{{ n.titulo }}</p>
                <p class="text-[11px] opacity-70 leading-tight mt-0.5 line-clamp-3 whitespace-pre-line">{{ n.descripcion }}</p>
                <div class="flex gap-2 mt-2">
                  <a routerLink="/novedades" class="btn btn-xs btn-ghost flex-1 text-[10px] font-bold">Ver todas</a>
                  <button (click)="descartarNovedad(n.id)" class="btn btn-xs btn-ghost flex-1 text-success text-[10px] font-bold bg-success/10">
                    <i class="ri-check-line"></i> Entendido
                  </button>
                </div>
              </div>
            }

            @for (m of comunicacion.respuestasSinLeer(); track m.id) {
              <div class="p-3 bg-primary/5 rounded-xl border border-primary/30">
                <span class="font-bold text-xs flex items-center gap-1.5 text-primary mb-1"><i class="ri-mail-open-line"></i> Respondimos tu mensaje</span>
                <p class="text-[11px] font-bold leading-tight">{{ m.asunto }}</p>
                <p class="text-[11px] opacity-70 leading-tight mt-0.5 line-clamp-2">{{ m.respuesta }}</p>
                <button (click)="verRespuestaBuzon(m.id)" class="btn btn-xs btn-ghost w-full mt-2 text-primary text-[10px] font-bold bg-primary/10">Ver respuesta</button>
              </div>
            }

            @if (comunicacion.buzonNuevos() > 0) {
              <a routerLink="/buzon" class="block p-3 bg-warning/5 rounded-xl border border-warning/30 hover:bg-warning/10">
                <span class="font-bold text-xs flex items-center gap-1.5 text-warning"><i class="ri-inbox-line"></i> Buzón de talleres</span>
                <p class="text-[11px] opacity-70 leading-tight mt-0.5">
                  {{ comunicacion.buzonNuevos() }} {{ comunicacion.buzonNuevos() === 1 ? 'mensaje nuevo' : 'mensajes nuevos' }} por atender.
                </p>
              </a>
            }

            @for (ev of preciosManoObra(); track ev.id) {
              <div class="p-3 bg-base-200/50 rounded-xl border border-base-300 hover:border-warning/30 transition-colors">
                <div class="flex items-center justify-between w-full mb-1">
                  <span class="font-bold text-xs flex items-center gap-1.5 text-warning"><i class="ri-history-line"></i> Precio de mano de obra</span>
                  <span class="text-[9px] font-bold opacity-40 uppercase">{{ ev.ts | date:'dd/MM HH:mm' }}</span>
                </div>
                <p class="text-[11px] opacity-70 leading-tight">
                  <strong>{{ ev.actor.nombre }}</strong> cobró <strong>{{ ev.detalle.nombre }}</strong>
                  @if (ev.detalle.cantidad > 1) { (x{{ ev.detalle.cantidad }}) }
                  en <strong>{{ ev.detalle.precio_aplicado | currency }}</strong>
                  ({{ ev.detalle.origen_referencia === 'OS' ? 'la OS decía' : 'catálogo' }}: {{ ev.detalle.precio_referencia | currency }}).
                </p>
                <p class="text-[10px] opacity-60 mt-0.5 font-mono">
                  {{ ev.venta_folio }}@if (ev.orden_folio) { · {{ ev.orden_folio }} }
                  · <span [class.text-error]="ev.detalle.diferencia_total < 0" [class.text-success]="ev.detalle.diferencia_total > 0">
                    {{ ev.detalle.diferencia_total > 0 ? '+' : '' }}{{ ev.detalle.diferencia_total | currency }}
                  </span>
                </p>
                <button (click)="revisarPrecioManoObra(ev.id)" class="btn btn-xs btn-ghost w-full mt-2 text-warning text-[10px] font-bold bg-warning/10">
                  <i class="ri-check-line"></i> Revisado
                </button>
              </div>
            }

            @for (auth of autorizacionesPendientes(); track auth.id) {
              <div class="p-3 bg-base-200/50 rounded-xl border border-base-300 hover:border-warning/30 transition-colors">
                <div class="flex items-center justify-between w-full mb-1">
                  <span class="font-bold text-xs flex items-center gap-1.5 text-warning"><i class="ri-price-tag-3-line"></i> Autorización de Precio</span>
                  <span class="text-[9px] font-bold opacity-40 uppercase">{{ auth.createdAt | date:'shortTime' }}</span>
                </div>
                <p class="text-[11px] opacity-70 leading-tight mb-3">
                  <strong>{{ auth.solicitante?.nombre }}</strong> solicita precio especial de <strong>${{ auth.metadata?.precio_solicitado }}</strong> para <strong>{{ auth.metadata?.producto_nombre }}</strong> (Base: ${{ auth.metadata?.precio_base }}).
                </p>
                <div class="flex gap-2 w-full">
                  <button (click)="responderAutorizacion(auth.id!, 'APROBADA')" class="btn btn-xs btn-primary flex-1 shadow-sm font-bold text-[10px]">Aprobar</button>
                  <button (click)="responderAutorizacion(auth.id!, 'RECHAZADA')" class="btn btn-xs btn-outline btn-error font-bold text-[10px]">Denegar</button>
                </div>
              </div>
            }
          </div>
          @if (currentUser()?.user?.grupo !== 'SUPER_ADMIN') {
            <div class="border-t border-base-200 p-2 grid grid-cols-2 gap-1">
              <a routerLink="/novedades" (click)="onNavClick()" class="btn btn-xs btn-ghost gap-1 text-[10px] font-bold">
                <i class="ri-megaphone-line"></i> Novedades
              </a>
              <a routerLink="/buzon" (click)="onNavClick()" class="btn btn-xs btn-ghost gap-1 text-[10px] font-bold">
                <i class="ri-chat-smile-2-line"></i> Quejas y sugerencias
              </a>
            </div>
          }
        </div>
      </div>
    </div>

    <!-- User -->
    <div class="border-t border-neutral-content/10 p-3 shrink-0">
      @if (sidebarOpen()) {
      <div class="flex items-center gap-3">
        <div class="avatar placeholder">
          <div class="bg-secondary/20 text-white rounded-full w-8 flex items-center justify-center border border-secondary/40">
            <i [class]="userIcon" class="text-lg"></i>
          </div>
        </div>
        <div class="flex-1 min-w-0">
          <p class="text-sm font-medium truncate">{{ currentUser()?.user?.name }}</p>
          <p class="text-xs text-neutral-content/50 capitalize truncate">{{ currentUser()?.user?.grupo }}</p>
        </div>
        <button (click)="logout()" class="btn btn-ghost btn-md btn-square text-error/60 hover:text-error hover:bg-error/10 transition-all border border-transparent hover:border-error/20"
          title="Cerrar sesión">
          <i class="ri-logout-box-r-line text-xl"></i>
        </button>
      </div>
      <div class="mt-2 pt-2 border-t border-neutral-content/10 flex items-center justify-between gap-2 text-[10px] text-neutral-content/40 px-1">
        <span class="flex items-center gap-2">
          v{{ version }}
          <!-- Tema claro/oscuro: acceso discreto para todos los roles (Configuración es sólo ADMIN) -->
          <button type="button" (click)="themeService.toggle()"
            class="hover:text-neutral-content/80 transition-colors"
            [attr.aria-label]="themeService.isDark() ? 'Activar tema claro' : 'Activar tema oscuro'"
            [title]="themeService.isDark() ? 'Tema claro' : 'Tema oscuro'">
            <i class="text-sm" [class]="themeService.isDark() ? 'ri-sun-line' : 'ri-moon-line'" aria-hidden="true"></i>
          </button>
        </span>
        <span class="flex items-center gap-2">
          @if (currentUser()?.user?.grupo !== 'SUPER_ADMIN') {
            <a routerLink="/novedades" (click)="onNavClick()" class="hover:text-neutral-content/80 transition-colors" title="Novedades">
              <i class="ri-megaphone-line text-sm" aria-hidden="true"></i><span class="sr-only">Novedades</span>
            </a>
            <a routerLink="/buzon" (click)="onNavClick()" class="hover:text-neutral-content/80 transition-colors" title="Quejas y sugerencias">
              <i class="ri-chat-smile-2-line text-sm" aria-hidden="true"></i><span class="sr-only">Quejas y sugerencias</span>
            </a>
          }
          <a routerLink="/terminos-y-condiciones" target="_blank" class="hover:text-neutral-content/80 hover:underline transition-colors">Términos y Condiciones</a>
        </span>
      </div>
      } @else {
      <button (click)="logout()" class="btn btn-ghost btn-md btn-square w-full text-error/60 hover:text-error hover:bg-error/10 transition-all"
        title="Cerrar sesión">
        <i class="ri-logout-box-r-line text-xl"></i>
      </button>
      <div class="mt-1 text-center text-[9px] text-neutral-content/30" [title]="'v' + version">
        <span>v{{ version }}</span>
      </div>
      }
    </div>
  </aside>

  <!-- Main -->
  <div class="flex-1 flex flex-col overflow-hidden relative">

    <!-- Abrir el menú en móvil: el toggle del sidebar viaja con el cajón, así que
         cuando está cerrado hace falta un acceso fijo en el contenido. -->
    <button type="button" (click)="toggleSidebar()" aria-label="Abrir menú"
      [attr.aria-expanded]="sidebarOpen()"
      class="lg:hidden absolute top-4 left-4 z-30 btn btn-circle btn-ghost bg-base-100/80 backdrop-blur shadow-sm border border-base-200">
      <i class="ri-menu-line text-xl opacity-70"></i>
      <!-- Las notificaciones viven en el cajón: el punto (con pulso) avisa que hay pendientes -->
      @if (totalNotificaciones() > 0) {
        <span class="absolute top-1.5 right-1.5 w-2.5 h-2.5 rounded-full bg-error animate-ping opacity-75" aria-hidden="true"></span>
        <span class="absolute top-1.5 right-1.5 w-2.5 h-2.5 rounded-full bg-error" aria-hidden="true"></span>
      }
    </button>

    <!-- Sin barra flotante arriba: en escritorio el contenido arranca pegado; en
         móvil se deja hueco sólo para el botón del menú. -->
    <main class="flex-1 min-w-0 overflow-auto page-enter transition-all duration-300"
          [class]="isActive('/punto-venta') ? 'pt-16 md:pt-4' : 'pt-16 lg:pt-4'">
      <!-- Alerta de Sucursal Faltante -->
      @if (missingSucursal()) {
        <div class="px-4 mb-4 animate-in slide-in-from-top duration-500">
          <div class="alert alert-warning shadow-lg border-warning/20 bg-warning/10 backdrop-blur-md rounded-2xl flex items-center justify-between">
            <div class="flex items-center gap-3">
              <div class="w-10 h-10 rounded-full bg-warning/20 flex items-center justify-center text-warning">
                <i class="ri-error-warning-fill text-2xl"></i>
              </div>
              <div>
                <h3 class="font-black text-[10px] uppercase tracking-widest opacity-70">Contexto Requerido</h3>
                <p class="text-xs font-bold leading-tight">No tienes una sucursal activa. Selecciona una o refresca tu perfil.</p>
              </div>
            </div>
            <button (click)="refreshProfile()" class="btn btn-sm btn-warning font-black text-[10px] uppercase tracking-widest px-6 rounded-xl">
              <i class="ri-refresh-line"></i> Refrescar
            </button>
          </div>
        </div>
      }
      <router-outlet />
    </main>
  <!-- Overlay de Cambio de Sucursal -->
  @if (switchingBranch()) {
    <div class="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-base-300/40 backdrop-blur-xl animate-in fade-in duration-500">
      <div class="glass-card p-12 rounded-[48px] shadow-premium flex flex-col items-center border-white/20">
        <!-- Banner animado de marca -->
        <img src="/assets/branding/mekanics_banner_animado.gif"
             alt="Mekanics Manager" class="w-72 max-w-[80vw] rounded-2xl bg-base-100 p-4 shadow-vibrant" />
        <h2 class="mt-8 text-3xl font-black uppercase tracking-[0.3em] text-base-content animate-pulse text-center">
          Cambiando de sede
        </h2>
        <div class="mt-4 flex items-center gap-2 px-6 py-2 bg-primary/10 rounded-full border border-primary/20">
          <span class="loading loading-dots loading-xs text-primary"></span>
          <p class="text-[10px] text-primary font-black uppercase tracking-widest">
            Sincronizando: {{ targetBranchName() }}
          </p>
        </div>
      </div>
      
      <!-- Efectos de Luces de Fondo -->
      <div class="absolute top-1/4 left-1/4 w-[600px] h-[600px] bg-primary/20 rounded-full blur-[150px] -z-10 animate-pulse"></div>
      <div class="absolute bottom-1/4 right-1/4 w-[500px] h-[500px] bg-secondary/10 rounded-full blur-[150px] -z-10"></div>
    </div>
  }
</div>

</div>
